import React from "react";
import { Button } from "../Button/Button";
import ChevronBackIcon from "../../icons/ChevronBack";
import ChevronRightIcon from "../../icons/ChevronRight";
import styles from "./Table.module.scss";

interface TablePaginationProps {
    currentPage: number;
    onFirstPage: () => void;
    onPrevPage: () => void;
    onNextPage: () => void;
    isNextDisabled?: boolean;
    showPrevButton?: boolean;
    showFirstPageButton?: boolean;
    showNextButton?: boolean;
    showPageNumber?: boolean;
    pageNumberText?: string;
    className?: string;
    customButtons?: React.ReactNode;
    buttonClassName?: string;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
    currentPage,
    onFirstPage,
    onPrevPage,
    onNextPage,
    isNextDisabled = false,
    showPrevButton = true,
    showFirstPageButton = true,
    showNextButton = true,
    showPageNumber = true,
    pageNumberText,
    className,
    customButtons,
    buttonClassName,
}) => {
    return (
        <div className={`${styles.tablePagination} ${className || ""}`}>
            <div className={styles.paginationLeft}>
                {showFirstPageButton && (
                    <Button
                        onClick={onFirstPage}
                        disabled={currentPage === 1}
                        className={`${styles.tablePaginationButton} ${
                            buttonClassName || ""
                        }`}
                        variant="normal"
                        iconLeft={<ChevronBackIcon />}
                    >
                        First Page
                    </Button>
                )}
                {showPrevButton && currentPage > 1 && (
                    <Button
                        onClick={onPrevPage}
                        className={`${styles.tablePaginationButton} ${
                            buttonClassName || ""
                        }`}
                        variant="normal"
                    >
                        Prev
                    </Button>
                )}
            </div>

            <div className={styles.paginationCenter}>
                {showPageNumber && (
                    <span className={styles.pageNumber}>
                        {pageNumberText || `Page ${currentPage}`}
                    </span>
                )}
            </div>

            <div className={styles.paginationRight}>
                {showNextButton && (
                    <Button
                        onClick={onNextPage}
                        variant="normal"
                        disabled={isNextDisabled}
                        className={`${styles.tablePaginationButton} ${
                            buttonClassName || ""
                        }`}
                        iconRight={<ChevronRightIcon />}
                    >
                        Next
                    </Button>
                )}
                {customButtons}
            </div>
        </div>
    );
};

export default TablePagination;
